import { render } from "./CurrentSubscriptionsComponent.vue?vue&type=template&id=0cb12690"
import script from "./CurrentSubscriptionsComponent.vue?vue&type=script&lang=js"
export * from "./CurrentSubscriptionsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__